import { render, staticRenderFns } from "./GalleryPreview.vue?vue&type=template&id=32f60957&scoped=true&"
import script from "./GalleryPreview.vue?vue&type=script&lang=js&"
export * from "./GalleryPreview.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPreview.vue?vue&type=style&index=0&id=32f60957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f60957",
  null
  
)

export default component.exports